import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function getTestAdminTestResults(id, normingStatus) {
	if (normingStatus) {
		return fetch(
			`${ENDPOINT_URL}/normingtests/self`,
			getFetchOptions({
				method: 'GET',
			})
		)
			.then((response) => {
				if (!response.ok) {
					throw response;
				}
				return response.json();
			})
			.catch((err) => {
				return Promise.reject(apiErrorHandling(err));
			});
	}

	return fetch(
		`${ENDPOINT_URL}/tests/self`,
		getFetchOptions({
			method: 'GET',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
